import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Unhurried",
    body: "We protect slowness. No bells, no levels, no leaderboards — just long afternoons where a child can finish a thought, a tower, or a story at their own pace.",
    align: "lg:mr-auto lg:text-left",
  },
  {
    n: "02",
    title: "Tactile",
    body: "Clay under fingernails, wool between fingers, sawdust on sleeves. We believe hands teach what screens cannot, so making sits at the heart of everything here.",
    align: "lg:ml-auto lg:text-right",
  },
  {
    n: "03",
    title: "Imaginative",
    body: "Stories are not a break from learning; they are the doorway into it. We read aloud every single day, and let children argue with endings and invent their own.",
    align: "lg:mr-auto lg:text-left",
  },
  {
    n: "04",
    title: "Shared",
    body: "A library is a table, not a shelf. Parents, grandparents, educators and neighbours all pull up a chair — because children grow best inside a community that reads together.",
    align: "lg:ml-auto lg:text-right",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative overflow-hidden bg-ink py-28 text-cream md:py-40"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-10 top-10 select-none font-serif text-[20rem] italic leading-none text-cream/5"
    >
      &amp;
    </div>

    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="mb-6 text-xs font-semibold uppercase tracking-[0.25em] text-terracotta">
          02 · Our Manifesto
        </p>
        <h2 className="max-w-3xl font-serif text-4xl leading-tight tracking-tight sm:text-5xl md:text-6xl">
          Four quiet promises we make to every child who <em className="text-sage">walks in.</em>
        </h2>
      </Reveal>

      <div className="mt-24 space-y-24 md:space-y-32">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={0.05} y={48}>
            <div data-testid={`manifesto-chapter-${c.n}`} className={`relative max-w-2xl ${c.align}`}>
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-16 left-0 select-none font-serif text-[7rem] leading-none text-cream/10 md:-top-24 md:text-[10rem]"
              >
                {c.n}
              </span>
              <h3 className="relative font-serif text-3xl italic text-terracotta sm:text-4xl md:text-5xl">
                {c.title}
              </h3>
              <p className="relative mt-6 text-base leading-relaxed text-cream/75 md:text-lg">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
